import cookie from "react-cookies";
import { RIMS_COOKIE_CONSTANTS } from "../constants";

export function logoutFunction() {
  localStorage.clear();
}

export function getURLDomain() {
  const splitByDot = window.location.hostname.split(".");
  const newArray = splitByDot.slice(1);
  const domainName = newArray.join(".");

  return domainName;
}

export const actionAlwaysPinnedRight = (originArr?: string[]) => {
  if (Array.isArray(originArr)) {
    const pinnedRightLen = originArr.length;
    if (originArr[pinnedRightLen - 1] !== "action") {
      const tempPinnedRight = originArr.filter((i) => i !== "action");
      tempPinnedRight.push("action");
      return tempPinnedRight;
    }
  }
  return originArr;
};

export const moduleForwardFormat = (
  moduleName: string,
  url: string
): string => {
  if (!moduleName || !url) return "";
  const URLDomain = getURLDomain();
  const parsedUrl = new URL(url);
  const hostPath = `https://app.${URLDomain}/${moduleName}`;
  const pathname = encodeURIComponent(parsedUrl.pathname);
  const searchParams = new URLSearchParams(parsedUrl.search);
  // Encode each query parameter
  const encodedQueries = Array.from(searchParams.entries())
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
  // Construct the final URL
  const entry = `${hostPath}?modulePath=${pathname}${
    encodedQueries ? `&${encodedQueries}` : ""
  }`;
  // console.log(entry);
  return entry;
};
